import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CryptoJS from "crypto-js";
import { Box, HStack, Text, VStack, useMediaQuery } from "native-base";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../utils/fonts";
import { COLORS } from "../../../utils/colors";
import { eventsImageSVG, uploadIconSVG } from "../../../utils/svg";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";
import config from "../../../utils/config";
import CustomModal from "../../../components/modal";
import CustomButton from "../../../components/button";
import CommonHeading from "../../../components/headings";
import { RequestDetailsPhotoListing, UploadNewPhoto } from "./modalChildren";
import { uploadFileAPI } from "../../../api/apis/workflow";
import { Toaster } from "../../../components/toaster";
import { hasPermission, statusMap } from "../../../utils/permission";
import CommonAvatar from "../../../components/avatar";
import DividerLine from "../../../components/divider";
import ContainerCards from "../../../components/cards";
import { LoaderAnimation } from "../../../components/spinner";
import MobileModelSheet from "../../../components/actionSheet";
import { isVideoByExtension } from "../../../utils/fileUtils";

const PhotosListing = ({
  getImages,
  images,
  userImageCard,
  eventsDetail,
  updateWorkflow,
  imageFormData,
  getUserImagesUnderReviewCard,
  scrollToTop = () => {},
  isLoading = true,
}) => {
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [showModal, setShowModal] = useState(false);
  const [uploadImages, setUploadImages] = useState([]);
  const [uploadImageFiles, setUploadImageFiles] = useState([]);
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [showButtons, setShowButtons] = useState(false);
  const [forceRemount, setForceRemount] = useState(false);
  const [isFirefox, setIsFirefox] = useState(false);

  useEffect(() => {
    // Check if the browser is Firefox
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("firefox")) {
      setIsFirefox(true);
    }
  }, []);

  const openModal = () => {
    !MobileWindow && scrollToTop();
    setShowModal(true);
    setForceRemount(!forceRemount);
  };

  const closeModal = () => {
    setShowModal(false);
    setUploadImages([]);
    setUploadImageFiles([]);
    setForceRemount(!forceRemount);
  };

  const handleImagesDeleted = () => {
    // Refresh the images after deletion
    if (getImages && eventsDetail && eventsDetail._id) {
      getImages(eventsDetail._id);
    }
  };

  const getStartDateFormat = (dateString) => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    }
    function formatDate(date) {
      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
        ].join("-") +
        "T" +
        [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
          padTo2Digits(date.getSeconds()),
        ].join(":") +
        "." +
        "616838+00:00"
      );
    }
    const formattedDate = formatDate(date);

    return formattedDate;
  };

  const uploadFilesToServer = async (data, fileType = "image") => {
    let docs = [];
    let res = await uploadFileAPI(data, fileType, fileType);

    res &&
      res.map((item) => {
        if (item.error) {
          toaster("Upload file failed", "error", "error");
          return;
        }
        if (item.data.data.data) {
          docs.push({
            doc_type: item.data.data.data.doc_type,
            file_size: item.data.data.data.file_size.toString(),
            file_name: item.data.data.data.file_name,
            uploaded_time: new Date(),
            media_id: item.data.data.data.media_id,
          });
        }
      });

    return docs;
  };

  const uploadImage = async () => {
    LoaderAnimation.show();
    if (uploadImageFiles.length === 0) {
      toaster("Please add images or videos to upload", "error", "error");
      LoaderAnimation.hide();
      return;
    }

    // Separate images and videos
    const imageFiles = uploadImageFiles.filter(file => {
      return !isVideoByExtension(file);
    });
    
    const videoFiles = uploadImageFiles.filter(file => {
      return isVideoByExtension(file);
    });

    let allDocs = [];

    // Upload images
    if (imageFiles.length > 0) {
      let imageRes = await uploadFilesToServer(imageFiles, "image");
      if (imageRes) {
        allDocs = [...allDocs, ...imageRes];
      }
    }

    // Upload videos
    if (videoFiles.length > 0) {
      let videoRes = await uploadFilesToServer(videoFiles, "video");
      if (videoRes) {
        allDocs = [...allDocs, ...videoRes];
      }
    }

    let res = allDocs;
    let allImages = [];
    res &&
      res.map((item) => {
        let payload = { ...imageFormData };
        payload["starts_at"] = getStartDateFormat(eventsDetail["from_date"]);
        payload["ends_at"] = getStartDateFormat(eventsDetail["to_date"]);
        payload.event_id = eventsDetail._id;
        payload.type = item.file_type || "image";
        payload.doc_type = item.doc_type;
        payload.file_size = item.file_size;
        payload.file_name = item.file_name;
        payload.added_by = userInfo.user_id;
        payload.uploaded_time = new Date();
        payload.media_id = item.media_id;
        delete payload["_id"];
        delete payload["workflow_id"];
        delete payload["current_step"];

        allImages.push(payload);
      });

    await updateWorkflow(allImages, "ADD_IMAGE", "image");
    await getImages(eventsDetail._id);
    // hasPermission("USER_IMAGE_UNDER_REVIEW_CARD") &&
    //   (await getUserImagesUnderReviewCard(eventsDetail._id));
    LoaderAnimation.hide();
    closeModal();
  };

  const modalHeader = <Text>Add Photo/Video</Text>;
  const modalFooter = (
    <Box width={MobileWindow && "100%"}>
      <CustomButton
        onPress={() => {
          // if (!buttonActive) {
          //   setButtonActive(true);

          // } else if (buttonActive) return;
          uploadImage();
        }}
        text="Submit"
        color={COLORS.WHITE_COLOR}
      />
    </Box>
  );

  const photoReview = (images, uploaded_by, data, uploaded_time) => {
    const getFormattedDate = (dates) => {
      const originalDate = new Date(dates);
      const formattedDate = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(originalDate);

      return formattedDate;
    };

    return (
      <VStack
        space={4}
        w="100%"
        pl={4}
        py={MobileWindow && 3}
        pr={MobileWindow && 4}
      >
        <HStack space={4}>
          <CommonAvatar
            bgcolor={COLORS.PARTNERS_CARD_COLOR}
            view="0 -5 20 30"
            svgwh="50"
            svg={eventsImageSVG}
            size="md"
          />
          <HStack w="89%" justifyContent="space-between" alignItems="center">
            <Box w={MobileWindow && "inherit"} mt={1}>
              <>
                <Text
                  fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                >
                  {hasPermission("USER_IMAGE_UNDER_REVIEW_CARD")
                    ? "Under Review"
                    : `Uploaded by ${uploaded_by}`}
                </Text>
                <HStack mt={1}>
                  <Text>{images} Media</Text>
                  <DividerLine />
                  <Text>
                    {uploaded_time && getFormattedDate(uploaded_time)}
                  </Text>
                </HStack>
              </>
            </Box>
            {!MobileWindow && (
              <Link
                style={{ textDecoration: "none" }}
                to={"/event-detail/photo-detail"}
              >
                <CustomButton
                  onPress={() => {
                    sessionStorage.setItem(
                      "user_image",
                      CryptoJS.AES.encrypt(
                        JSON.stringify(data),
                        config.imageKey
                      ).toString()
                    );
                  }}
                  text="View All Media"
                  width="fit-content"
                  py="10px"
                />
              </Link>
            )}
          </HStack>
        </HStack>
        {MobileWindow && (
          <Link
            style={{ textDecoration: "none" }}
            to={"/event-detail/photo-detail"}
          >
            <CustomButton
              onPress={() => {
                sessionStorage.setItem(
                  "user_image",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(data),
                    config.imageKey
                  ).toString()
                );
              }}
              text="View All Media"
              width="100%"
              py="10px"
            />
          </Link>
        )}
      </VStack>
    );
  };

  return (
    <VStack>
      <>
        <HStack justifyContent="space-between">
          {showButtons && (
            <>
              <Box>
                <CommonHeading text="Media" />
              </Box>

              {statusMap.indexOf(eventsDetail.status) >= 2 && (
                <CustomButton
                  endIcon={uploadIconSVG}
                  bgColor={COLORS.UPLOAD_BUTTON_COLOR}
                  borderRadius="50px"
                  text={!MobileWindow && "Upload Photo/Video"}
                  textColor={COLORS.BLACK_COLOR}
                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                  width="auto"
                  py={2}
                  onPress={openModal}
                />
              )}
            </>
          )}
        </HStack>

        <Box mt={showButtons && 3}>
          <RequestDetailsPhotoListing
            eventsDetail={eventsDetail}
            openPhotoModal={openModal}
            showButtons={showButtons}
            setShowButtons={setShowButtons}
            images={images}
            scrollToTop={scrollToTop}
            isLoading={isLoading}
            onImagesDeleted={handleImagesDeleted}
          />
          {images &&
            images[0] &&
            images[0].pagination &&
            images[0].pagination[0] &&
            images[0].pagination[0].total &&
            images[0].pagination[0].total > 6 && (
              <div style={{ margin: "auto" }}>
                <Link
                  style={{ textDecoration: "none" }}
                  to={"/event-detail/all-photo-detail"}
                >
                  <CustomButton
                    text="View All Media"
                    width="fit-content"
                    py="10px"
                    mt="5"
                  />
                </Link>
              </div>
            )}
          <br></br>

          {userImageCard &&
            userImageCard.length > 0 &&
            userImageCard.map((item) => {
              return (
                <div style={{ marginTop: isFirefox && "20px" }}>
                  <ContainerCards
                    width="100%"
                    height={"auto"}
                    minH={"100px"}
                    background={COLORS.WHITE_COLOR}
                    justifyContent="center"
                  >
                    {photoReview(
                      item?.user_image_count,
                      item?.user_name,
                      item?.pending_images,
                      item?.pending_images?.[item.pending_images.length - 1]
                        .uploaded_time
                    )}
                  </ContainerCards>
                  <br></br>
                </div>
              );
            })}
        </Box>
      </>
      {!MobileWindow ? (
        <CustomModal
          isOpen={showModal}
          onClose={closeModal}
          top={uploadImages.length === 0 ? "150px" : "50px"}
          header={modalHeader}
          body={
            <UploadNewPhoto
              uploadImages={uploadImages}
              setUploadImages={setUploadImages}
              uploadImageFiles={uploadImageFiles}
              setUploadImageFiles={setUploadImageFiles}
              forceRemount={forceRemount}
            />
          }
          footer={modalFooter}
          width={MobileWindow ? "100%" : "70%"}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={modalHeader}
          body={
            <UploadNewPhoto
              uploadImages={uploadImages}
              setUploadImages={setUploadImages}
              uploadImageFiles={uploadImageFiles}
              setUploadImageFiles={setUploadImageFiles}
              forceRemount={forceRemount}
            />
          }
          footer={modalFooter}
        />
      )}
    </VStack>
  );
};

export default PhotosListing;
